<template>
    <guide-page v-bind:config="pageConfig" :wxa-page="wxaPage" :wxa-page-param="wxaPageParam" :shareHaderName="shareHaderName"></guide-page>
</template>

<script>
import sensorsdata from 'sa-sdk-javascript';
import GuidePage from '../component/GuidePage.vue';

export default {
  name: 'UploadData',
  components: {
    guidePage: GuidePage,
  },
  data() {
    return {
      wxaPage: 'pages/me/guide/guide-page/guide-page',
      wxaPageParam: 'key=5',
      shareHaderName: '上传资料',
      pageConfig: {
        sections: [
          {
            head: {
              title: '上传资料（顾客操作）',
            },
            steps: [
              {
                description: [
                  '顾客通过分享的链接或扫描二维码后打开，点击「开始办理」填写出行信息；',
                ],
                sub: [
                  {
                    images: [{ name: '5_01' }],
                  },
                ],
              },
              {
                description: [
                  '选择预计出行日期，点击「新增申请人」，填写申请人姓名、选择旅客身份，点击「确定」进入下一步；',
                ],
                sub: [
                  {
                    images: [
                      {
                        name: '5_02',
                        tips: {
                          position: {
                            left: 375,
                            top: 90,
                          },
                          content: '* 用户首次使用，需要绑定手机号哦',
                        },
                      },
                    ],
                  },
                ],
              },
              {
                description: [
                  '根据办理的商品要求，上传相关签证资料；资料上传完，点击保存进入申请表填写，如无申请表则直接进入订单确认；',
                ],
                sub: [
                  {
                    images: [{ name: '5_03' }],
                  },
                ],
              },
              {
                description: [
                  '申请表填写，请根据真实的情况填写；填写完毕进入订单确认页；',
                ],
                sub: [
                  {
                    images: [{ name: '5_04' }],
                  },
                ],
              },
              {
                description: [
                  '点击「提交订单」该订单将提交至店铺店员，由店员完成支付。',
                ],
                sub: [
                  {
                    images: [{ name: '5_05' }],
                  },
                ],
              },
            ],
          },
        ],
      },
    };
  },
  mounted() {
    sensorsdata.track('UserGuide', {
      guide_name: '上传资料',
    });
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/guide/sub/UploadData.vue